
/* injects from baggage-loader */

import loadTypes from 'utils/loadTypes'

export const APP_SETTINGS = loadTypes('APP_SETTINGS')

const initialState = {
  isFetching: false,
  successMessage: null,
  errorMessage: null,
  maintenanceStatus: false
}

export default function appSettings(state = initialState, action) {
  switch (action.type) {
    case APP_SETTINGS.REQUEST:
      return {
        ...state,
        isFetching: true,
        successMessage: null,
        errorMessage: null
      }

    case APP_SETTINGS.SUCCESS:
      const maintenanceStatus = (action.response.settings || []).find(item => item?.key === 'MaintenanceStatus')
      return {
        ...state,
        isFetching: false,
        successMessage: action.response.success || '',
        errorMessage: null,
        maintenanceStatus: maintenanceStatus?.value || false
      }

    case APP_SETTINGS.FAILURE:
      return {
        ...state,
        isFetching: false,
        successMessage: null,
        errorMessage: action.message
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/app-settings/index.js